import { makeStyles } from '@lifeomic/chroma-react/styles';
import { PlotContainer } from '@lifeomic/phc-web-toolkit/src/components/Plot/PlotContainer';
import * as React from 'react';
import Plot from 'react-plotly.js';
import { defineMessages, useIntl } from 'react-intl';

// We set a static height for the plot so that rendering inside of an
// ExpansionPanel component doesn't cause issues.
const plotHeight = 400;

const messages = defineMessages({
  noData: {
    id: 'pages.summary.pieChart.noData',
    defaultMessage: 'No results',
  },
});

const useStyles = makeStyles(() => ({
  root: {
    height: plotHeight,
  },
  plot: {
    width: '100%',
    height: '100%',
  },
}));

export const PieChart = ({
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  isLoading, // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  chartTitle, // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  data,
}) => {
  const classes = useStyles({});
  const { formatMessage } = useIntl();

  const hasData = data && data[0].values.length > 0;

  return (
    <PlotContainer className={classes.root} isLoading={isLoading}>
      <Plot
        className={classes.plot}
        useResizeHandler
        data={data}
        layout={
          hasData
            ? {
                title: chartTitle,
                hovermode: 'x unified' as any,
                autosize: true,
              }
            : {
                title: chartTitle,
                annotations: [
                  {
                    text: formatMessage(messages.noData),
                    xref: 'paper',
                    yref: 'paper',
                    showarrow: false,
                    font: {
                      size: 28,
                    },
                  },
                ],
              }
        }
      />
    </PlotContainer>
  );
};

export default PieChart;
